import styled from 'styled-components';
import { publicNavButtonHoverStyle, publicNavButtonStyle } from '../publicNavButtonStyle';
import UILink from 'UIComponents/link/UILink';
const PublicPageNavLink = styled(UILink).withConfig({
  displayName: "PublicPageNavLink",
  componentId: "lh3ezh-0"
})(["", " &:hover{color:", ";text-decoration:underline;", "}"], publicNavButtonStyle, props => props.theme.activeTheme === 'highContrast' && props.theme.colors.HIGH_CONTRAST_LINK, publicNavButtonHoverStyle);
export default PublicPageNavLink;